import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Container, Box, Tabs, Tab } from '@mui/material';
import BreadcrumbNav from '../components/BreadcrumbNav';
import EmailTemplateTab from '../components/settings/EmailTemplateTab';
import DocumentTemplateTab from '../components/settings/DocumentTemplateTab';

const SettingsPage = () => {
  const { t } = useTranslation(['pages', 'common', 'navigation']);
  const location = useLocation();
  const [tabValue, setTabValue] = useState(location.state?.activeTab || 0);
  
  // Handle route state for template selection
  useEffect(() => {
    if (location.state?.activeTab !== undefined) {
      setTabValue(location.state.activeTab);
    }
  }, [location.state]);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Container 
      maxWidth={false} 
      disableGutters
      sx={{
        pt: 2,
        marginBottom: 0,
        marginTop: 2,
        minHeight: 'calc(100vh - 100px)',
        px: 6,
        pb: 4,
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "0",
          margin: "0",
          mb: 2,
          gap: 2,
        }}
      >
        <BreadcrumbNav
          title={t('pages:settings.title')}
        />
      </Box>

      {/* Modern Tab Design */}
      <Box sx={{ 
        mb: 0,
        borderBottom: '1px solid #E5E7EB',
        backgroundColor: '#fff',
        borderRadius: '12px 12px 0 0',
        overflow: 'hidden',
      }}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          aria-label="settings tabs"
          sx={{
            minHeight: "44px",
            px: 1,
            pt: 0.5,
            "& .MuiTabs-flexContainer": {
              backgroundColor: '#fff',
              gap: 0,
            },
            "& .MuiTabs-indicator": {
              height: '2px',
              borderRadius: '2px 2px 0 0',
              backgroundColor: '#3B82F6',
            },
            "& .MuiTab-root": {
              color: "#6B7280",
              minHeight: "44px",
              textTransform: "none",
              fontFamily: "Fira Sans, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif",
              fontWeight: 500,
              fontSize: "13px",
              letterSpacing: '0.01em',
              px: 2.5,
              py: 1,
              mr: 0.5,
              borderRadius: '8px 8px 0 0',
              transition: 'all 0.2s ease',
              "&:hover": {
                color: "#374151",
                backgroundColor: '#F3F4F6',
              },
            },
            "& .Mui-selected": {
              color: "#3B82F6 !important",
              fontWeight: 600,
            },
          }}
        >
          <Tab label={t('pages:settings.email_templates')} />
          <Tab label={t('pages:settings.document_templates')} />
        </Tabs>
      </Box>

      {/* Tab Content */}
      <Box sx={{
        overflow: 'hidden',
      }}>
        {tabValue === 0 && (
          <EmailTemplateTab />
        )}

        {tabValue === 1 && (
          <DocumentTemplateTab 
            routeState={location.state}
          />
        )}
      </Box>
    </Container>
  );
};

export default SettingsPage;
